var map = {
	"./calendar.svg": "b8bd",
	"./check-green.svg": "81ed",
	"./checkbox.svg": "5b02",
	"./checkmark-white.svg": "6b43",
	"./chevron-down-black.svg": "60d8",
	"./chevron-forward-gray.svg": "9fbd",
	"./close.svg": "8b1b",
	"./comment.svg": "c47d",
	"./delete.svg": "0d45",
	"./edit.svg": "daf0",
	"./info.svg": "76ed",
	"./more.svg": "0f4c",
	"./plus.svg": "eb38",
	"./search.svg": "d103",
	"./target.svg": "0129",
	"./thumbs-down-gray.svg": "bdd6",
	"./thumbs-down-red.svg": "2742",
	"./thumbs-down.svg": "9a65",
	"./thumbs-up-gray.svg": "567d",
	"./thumbs-up-green.svg": "40b3",
	"./thumbs-up.svg": "fe9c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";